module.exports = __webpack_public_path__ + "static/media/faq-3.a1759461.png";